const config = {
  // eslint-disable-next-line no-undef
  NODE_ENV: process.env.NODE_ENV
}

export default config
